import * as React from 'react';
import Box from '@material-ui/core/Box';
import {withStyles} from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField, {TextFieldProps} from '@material-ui/core/TextField';

import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const StyledTextField = withStyles(theme => ({
    root: {
        width: '100%',

        '& input': {
            cursor: 'pointer',
            width: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        '& [class*="formControl"]': {
            cursor: 'pointer'
        },

        [theme.breakpoints.up('fmd')]: {
            width: 'inherit'
        }
    }
}))(TextField);

const StyledInputAdornment = withStyles(theme => ({
    root: {
        padding: theme.spacing(0, 2)
    }
}))(InputAdornment);

export type PopperInputProps = TextFieldProps & {
    open: boolean;
};

const PopperInput: React.FC<PopperInputProps> = ({open, ...props}: PopperInputProps) => {
    return (
        <StyledTextField
            {...props}
            variant="outlined"
            size="small"
            // notched={true}
            focused={open}
            InputProps={{
                // notched: true,
                readOnly: true,
                startAdornment: <Box pl={2} />,
                endAdornment: (
                    <StyledInputAdornment position="end">
                        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </StyledInputAdornment>
                )
            }}
        />
    );
};

export default PopperInput;
